const getSelectedFilterKeys = (selectedFilters) => Object.entries(selectedFilters)
    .filter(([, { selected }]) => selected)
    .map(([, { category, key }]) => ({ category, key }));
const checkStoreBySelectedFilters = (store, selectedFilters) => {
    const selectedFiltersKeys = getSelectedFilterKeys(selectedFilters);
    if (selectedFiltersKeys.length === 0) {
        return true;
    }
    return selectedFiltersKeys.every(({ key, category }) => {
        const storeFilter = store[category];
        return storeFilter?.find((filter) => filter.key === key)?.is_available === "true";
    });
};
export const getStoresFilteredBySelectedFilters = (stores, selectedFilters) => stores.filter((store) => checkStoreBySelectedFilters(store, selectedFilters));
//# sourceMappingURL=getStoresFilteredBySelectedFilters.js.map